import { Injectable } from '@angular/core';
import { CommonConstants, ConfirmationFlowConstants, UTagConstants, UTagPageIds } from '../constants/upplm.constants';
declare var $: any;
declare var window: any;

@Injectable()
export class UtagService implements ConfigUtag {

    private utag: any;
    private utag_data: any;
    constructor() {
        //(<any>window).utag_cfg_ovrd = { noview: true };
        //(<any>window).utag_data = {};

        this.utag = window.utag;
        this.utag_data = window.utag_data;

    }

    //--------------------------------------------------------------
    // start page
    //--------------------------------------------------------------
    utagForStartOfTheEvent(step: string, pageName: string) {
        this.resetUTAGData();
        let add_data: any;
        add_data = this.congifVariables(pageName, step);
        this.setUTAGData(add_data);
    }

    utagForButtons(linkName, linkType, page): void {
        this.resetUTAGData();

        let add_data: any;
        let item: any = new Object();
        switch (page) {
            case UTagConstants.PAGE_LOCATION_DETAIL:
                item = this.congifVariables(UTagConstants.UPPLM_LOCATION_DETAILS_START_SCREEN,
                    UTagConstants.UPPLM_LOCATION_DETAILS_START,
                    UTagConstants.UPPLM_LOCATION_DETAILS_START_SCREEN);
                break;
            case UTagConstants.PAGE_CONTACT_DETAIL:
                item = this.congifVariables(UTagConstants.UPPLM_CONTACT_DETAILS_START_SCREEN,
                    UTagConstants.UPPLM_CONTACT_DETAILS_START,
                    UTagConstants.UPPLM_CONTACT_DETAILS_START_SCREEN);
                break;
            case UTagConstants.PAGE_PLACARD_DETAIL:
                item = this.congifVariables(UTagConstants.UPPLM_PLACARD_DETAILS_START_SCREEN,
                    UTagConstants.UPPLM_PLACARD_DETAILS_START,
                    UTagConstants.UPPLM_PLACARD_DETAILS_START_SCREEN);
                break;
            case UTagConstants.PAGE_PICKUP_DETAIL:
                item = this.congifVariables(UTagConstants.UPPLM_PICKUP_DETAILS_START_SCREEN,
                    UTagConstants.UPPLM_PICKUP_DETAILS_START,
                    UTagConstants.UPPLM_PICKUP_DETAILS_START_SCREEN);
                break;
            case UTagConstants.PAGE_NOTIFICATION_DETAIL:
                item = this.congifVariables(UTagConstants.UPPLM_NOTIFICATION_DETAILS_START_SCREEN,
                    UTagConstants.UPPLM_NOTIFICATION_START,
                    UTagConstants.UPPLM_NOTIFICATION_DETAILS_START_SCREEN);
                break;
            case UTagConstants.PAGE_REVIEW:
                item = this.congifVariables(UTagConstants.UPPLM_REVIEW_START_SCREEN,
                    UTagConstants.UPPLM_REVIEW_START,
                    UTagConstants.UPPLM_REVIEW_START_SCREEN);
                break;
            case UTagConstants.PAGE_CONFIRMATION:
                item = this.congifVariables(UTagConstants.UPPLM_CONFIRMATION_START_SCREEN,
                    UTagConstants.UPPLM_CONFIRMATION_START,
                    UTagConstants.UPPLM_CONFIRMATION_START_SCREEN);
                break;
            case UTagConstants.PAGE_PALACARD_EXIST:
                item = this.congifVariables(UTagConstants.UPPLM_PLACARD_EXIST_START_SCREEN,
                    UTagConstants.UPPLM_PLACARD_EXIST_START,
                    UTagConstants.UPPLM_PLACARD_EXIST_START_SCREEN);
                break;
            default:
                break;
        }
        
        item.link_name = linkName
        item.link_type = linkType
        add_data = item;
        this.setUTAGData(add_data);
    }

    //--------------------------------------------------------------
    // Functions Configuration variables
    //--------------------------------------------------------------
    congifVariables(page_name: string, page_id: string);
    congifVariables(page_name: string, page_id: string, link_page: string);
    congifVariables(page_name: any, page_id: any, link_page?: any) {
        let item: any;
        if (link_page === null) {
            item = {
                'site_area': UTagConstants.UPPLM_SERVICES,
                'site_sub_area': UTagConstants.UPPLM,
                'referring_url': this.utag_data.referring_url,
                'page_name': page_name,
                'page_id': page_id
            };
        } else {
            item = {
                "site_area": UTagConstants.UPPLM_SERVICES,
                "site_sub_area": UTagConstants.UPPLM,
                "referring_url": this.utag_data.referring_url,
                "page_name": page_name,
                "page_id": page_id,
                "link_page": link_page
            };
        }
        return item;
    }

    //--------------------------------------------------------------
    // functions this class utag services
    //--------------------------------------------------------------
    public resetUTAGData(): void {
        if (typeof this.utag_data !== 'undefined' && this.utag_data !== undefined) {
            this.utag_data.gross_revenue = "";
            this.utag_data.net_revenue = "";
            this.utag_data.currency = "";
            this.utag_data.journey_step_number = "";
            this.utag_data.shipping_package_count = "";
            this.utag_data.link_name = "";
            this.utag_data.link_page = "";
            this.utag_data.link_type = "";
            this.utag_data.field_name = "";
            this.utag_data.form_name = "";
            this.utag_data.form_intent = "";
            this.utag_data.event_id = "0";
        }
    }
    private setUTAGData(data): void {
        if (typeof this.utag !== CommonConstants.UNDEFINED && this.utag !== undefined) {
            this.utag.view($.extend(this.utag_data, data), null);
            console.log(this.utag);
        }
    }
}